import { IComponentOptions } from 'angular';
import { GradPlanningWizardStepperCtrl } from './grad-planning-wizard-stepper.controller';

export const GradPlanningWizardStepperComponent: IComponentOptions = {
  bindings: {
    initialWizardState: '<',
  },
  controller: GradPlanningWizardStepperCtrl,
  template: require('./grad-planning-wizard-stepper.html'),
};
